
import { AppConstants as AppConstantsBase } from '@aston/foundation';
import { NgxCurrencyConfig, NgxCurrencyInputMode } from 'ngx-currency';

import { IFileUploadConfig } from './shared-module/models';

export class AppConstants extends AppConstantsBase {
	static CRITICAL_ERROR_RELOAD_TIMEOUT = 5000;

	static ADDRESS_COUNTRY_DEFAULT = 'France';

	static LOCALSTORAGE_KEYS = {
		...AppConstantsBase.LOCALSTORAGE_KEYS,
		POST_LOGIN_ROUTE: 'post_login_route',
	};

	static ANIMATED_SCROLL_ELEMENT_DEFAULT = '#main';

	static IMAGE_PREVIEW_MATCH = /^image/;
	static IFRAME_PREVIEW_MATCH = /\/pdf/;

	static FILE_UPLOAD_CONFIGS: Record<string, IFileUploadConfig> = {
		DEFAULT: {
			acceptExtensions: ['jpg', 'jpeg', 'png', 'gif', 'pdf'],
			maxSize: 4 * AppConstantsBase.MEGABYTE
		},
		TENANT_LOGO: {
			acceptExtensions: ['jpg', 'jpeg', 'png'],
			maxSize: 250 * AppConstantsBase.KILOBYTE,
			maxResolution: { width: 200, height: 200 },
		},
	};

	static CURRENCY_MASK_OPTIONS: NgxCurrencyConfig = {
		align: 'left',
		allowNegative: false,
		allowZero: false,
		decimal: ',',
		precision: 2,
		prefix: '',
		suffix: '',
		thousands: ' ',
		nullable: true,
		inputMode: NgxCurrencyInputMode.Natural
	};

	static CREATE_SUBSIDIARY_BLOCKED_REDIRECT_URL = 'https://www.astonai.com/';
}
